<script setup lang="ts">
import BackButton from "@/components/buttons/BackButton.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSafeBack, RouteName } from "@/utils/useSafeBack";
import { defineProps, withDefaults } from "vue";

const { safeBack } = useSafeBack();

const props = withDefaults(
  defineProps<{
    pageTitle: string;
    backRouteName?: RouteName;
    titleAlign: "left" | "center";
    onBack?: () => void;
  }>(),
  {
    titleAlign: "center",
    backRouteName: ROUTE_NAMES.HOME,
  }
);

const alignMap = {
  left: "text-left",
  center: "text-center w-full",
} as const;

const containerMap = {
  left: "flex gap-4",
  center: "relative",
};

function handleBack() {
  if (props.onBack) {
    props.onBack();
  } else {
    safeBack(props.backRouteName);
  }
}
</script>

<template>
  <div
    class="items-center xl:hidden mb-6"
    :class="containerMap[props.titleAlign]"
  >
    <div class="absolute left-0" v-if="titleAlign === 'center'">
      <BackButton @clicked="handleBack" />
    </div>
    <BackButton @clicked="handleBack" v-else />
    <h2
      class="text-2xl font-medium leading-[32px] text-brown"
      :class="alignMap[titleAlign]"
    >
      {{ pageTitle }}
    </h2>
  </div>
</template>
